import { ReactComponent as Stars } from '@packages/shared/assets/stars.svg';
import discount from '@packages/shared/assets/experts-catalogue/discount.png';
import Image from '@packages/shared/core/common/components/common/Image';
import Button from '@packages/shared/core/common/components/common/Button';
import { DataTestId } from '@packages/shared/core/common/constants/dataTestId';
import { ExpertCatalogueMobileProps } from '../ExpertCatalogueMobile';
import styles from './ExpertCatalogueDesktop.module.scss';

const maxSloganLength = 80;
const maxDescriptionLength = 265;

type ExpertCatalogueDesktopProps = ExpertCatalogueMobileProps;

const ExpertCatalogueDesktop = ({
  onExpertClick,
  onStartChat,
  info,
  price = '$3/min',
  discountText = 'Get 10 min for $1.99',
}: ExpertCatalogueDesktopProps) => {
  return (
    <div role="button" onClick={onExpertClick} className={styles.container}>
      <div className={styles.imageWrapper}>
        <Image
          src={info.image}
          className={styles.image}
          alt="expert"
          objectFit="cover"
          layout="fixed"
          width={180}
          height={180}
        />
      </div>

      <div className={styles.info}>
        <p className={styles.name}>{info.name}</p>

        <p className={styles.slogan}>{info.slogan.slice(0, maxSloganLength)}...</p>

        <p className={styles.description}>
          {info.description.slice(0, maxDescriptionLength)}

          {`...`}

          <span className={styles.more}>Read more</span>
        </p>
      </div>

      <div className={styles.awards}>
        <div className={styles.awardsTitle}>
          {info.rating}

          {` `}

          <Stars title="stars" />

          <p className={styles.awardsText}>Based on {info.review_count} reviews</p>
        </div>

        <div>
          <p className={styles.awardsTitle}>{info.total_orders}</p>

          <p className={styles.awardsText}>consultations done</p>
        </div>

        <div>
          <p className={styles.awardsTitle}>{info.experience} years</p>

          <p className={styles.awardsText}>of experience</p>
        </div>
      </div>

      <div className={styles.priceWrapper}>
        <div className={styles.discount}>
          <Image src={discount} layout="fill" alt="discount" />

          <p className={styles.discountText}>{discountText}</p>
        </div>

        <p className={styles.price}>{price}</p>

        <Button
          data-testid={DataTestId.START_CHAT_BUTTON}
          wrapperClassName={styles.buttonWrapper}
          className={styles.button}
          onClick={onStartChat}
        >
          Start chat
        </Button>
      </div>
    </div>
  );
};

export default ExpertCatalogueDesktop;
